import { createContext, useContext } from 'react';

export type UnsubmittedSessionsContextValue = {
  onSubmitSession: (appointmentId: string) => void;
  onToggleCancelSessionModal: (appointmentId: string) => void;
};

export const UnsubmittedSessionsContext = createContext<UnsubmittedSessionsContextValue>(null);

export const useUnsubmittedSessionsContent = () => useContext(UnsubmittedSessionsContext);
